
const getHaloVariations = (commonCanopies, commonVariaton) => {
	return {
		'2350': {
			...commonVariaton,
			size: {
				width: 0.026,
				height: 1,
				depth: 0.026
			},
			paddingTop: -1,
			familyName: 'halo',
			related: ['2350', '2351', '2355'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.563,
						depth: 0.563,
						height: 0.033
					},
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		},
		'2351': {
			...commonVariaton,
			size: {
				width: 0.026,
				height: 1,
				depth: 0.026
			},
			paddingTop: -1,
			familyName: 'halo',
			related: ['2351', '2350', '2355'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.563,
						depth: 0.563,
						height: 0.033
					},
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		},
		'2355': {
			...commonVariaton,
			size: {
				width: 0.026,
				height: 1,
				depth: 0.026
			},
			paddingTop: -1,
			familyName: 'halo',
			related: ['2351', '2350', '2355'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.05,
						depth: 0.05,
						height: 0.033
					},
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		}
	}
}

export default getHaloVariations